"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpErrorResponse = exports.FunctionalErrorMessage = void 0;
const tslib_1 = require("tslib");
require("reflect-metadata");
const class_validator_1 = require("class-validator");
const apigw_models_1 = require("@integration/apigw-models");
const class_transformer_1 = require("class-transformer");
const decorators_1 = require("../decorators");
class FunctionalErrorMessage extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: '1034', description: 'Functional error code' }),
    tslib_1.__metadata("design:type", String)
], FunctionalErrorMessage.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'Resource not available',
        description: 'Message describing what is the problem.',
    }),
    tslib_1.__metadata("design:type", String)
], FunctionalErrorMessage.prototype, "message", void 0);
exports.FunctionalErrorMessage = FunctionalErrorMessage;
/**
 * An HTTP Error
 * message and status code are returned in responses
 */
class HttpErrorResponse extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 400, description: 'HTTP Status Code' }),
    tslib_1.__metadata("design:type", Number)
], HttpErrorResponse.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'bad_request', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], HttpErrorResponse.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'Request body cannot be parsed',
        description: 'Message describing the error.',
    }),
    tslib_1.__metadata("design:type", String)
], HttpErrorResponse.prototype, "message", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, apigw_models_1.Docs)({
        example: '{flow_id: "1234"}',
        description: 'Gives the option to put additional information in the error details',
    }),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Object)
], HttpErrorResponse.prototype, "metaData", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => FunctionalErrorMessage),
    (0, apigw_models_1.Docs)({
        example: '[]',
        description: 'Error list of functional error',
    }),
    tslib_1.__metadata("design:type", Array)
], HttpErrorResponse.prototype, "errors", void 0);
exports.HttpErrorResponse = HttpErrorResponse;
